import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import { initRum } from "./integrations/datadog-rum";
import { FeatureFlagProvider } from "./config/FeatureFlagProvider";
import { AuthKitProvider } from "@workos-inc/authkit-react";
import "./styles/styles.scss";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "./utils/styleVariables";
import { getAuthConfig } from "./config/authConfig";
import Authenticated from "./Authenticated";

initRum();

const { clientId, redirectUri, isDev } = getAuthConfig();

ReactDOM.createRoot(document.getElementById("root")).render(
  <AuthKitProvider
    clientId={clientId}
    redirectUri={redirectUri}
    devMode={isDev}
    onRedirectCallback={(state) => {
      if (state?.returnTo) {
        window.history.replaceState(null, "", state.returnTo);
      }
    }}
  >
    <FeatureFlagProvider>
      <Provider store={store}>
        <Authenticated>
          <App />
        </Authenticated>
      </Provider>
    </FeatureFlagProvider>
  </AuthKitProvider>,
);
